import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id?: number;
  name: string;
  grand_child_name_ms: string;
  grand_child_name_zh: string;
  image_url: string;
  airports_en: string;
  airports_ms: string;
  airports_zh: string;
  grand_child_key_en: string;
  grand_child_key_ms: string;
  grand_child_key_zh: string;
  grand_redirect_url_en: string;
  grand_redirect_url_ms: string;
  grand_redirect_url_zh: string;
  child_heading_id: number;
  published: boolean;
}

// edit api call
const fetchSubCategoriesDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/get-grand-child-menu-items-taxonomy-data-list/${id}`);

  return response.data.data;
};

const useSubCategoriesDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["subCategoriesDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchSubCategoriesDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useSubCategoriesDocumentDetails };
